/**
 *  ExteriorCampaignDetailSidebar script file
**/

import { CHANNEL_OPTIONS_EXTERIOR } from '@/utils/campaignOptions'

export default {
  name: 'ExteriorCampaignDetailSidebar',
  mixins: [],
  components: {},
  props: {
    channel: {
      type: Object,
      required: true
    },
    expanded: {
      type: Boolean,
      default: true
    },
    kpis: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    productBlocks () {
      const blocks = {}
      for (const item of this.channel.products_adverts) {
        if (!blocks[item.product.id]) {
          blocks[item.product.id] = {
            product: item.product,
            adverts: []
          }
        }
        blocks[item.product.id].adverts.push(item.advert)
      }
      return blocks
    },
    isSignaling () {
      return this.channel.type === CHANNEL_OPTIONS_EXTERIOR.SIGNALING
    }
  },
  methods: {}
}
